import { LegalPageLayout, LegalSection } from "@/components/legal/LegalPageLayout";

export default function CookiesPolicy() {
  return (
    <LegalPageLayout eyebrow="Legal" title="Cookie Policy">
      <LegalSection heading="1. What Are Cookies" testid="cookies-section-what">
        <p>
          Cookies are small text files placed on your device when you visit a website. They help
          the site function properly, remember preferences, and provide basic insight into how the
          site is used. This Cookie Policy explains how Off-Grid Hydrogen Ltd. uses cookies on this
          website.
        </p>
      </LegalSection>

      <LegalSection heading="2. How We Use Cookies" testid="cookies-section-how">
        <p>
          We use cookies sparingly and only where they support the operation of the site or help us
          understand how visitors interact with our content. We do not use cookies to sell your
          data or build advertising profiles.
        </p>
      </LegalSection>

      <LegalSection heading="3. Types of Cookies We Use" testid="cookies-section-types">
        <ul className="list-disc pl-5 space-y-3">
          <li>
            <span className="text-ink font-medium">Essential cookies.</span> Required for the
            website to function correctly, such as maintaining form state while you complete a site
            assessment request. These cannot be disabled without affecting core functionality.
          </li>
          <li>
            <span className="text-ink font-medium">Performance &amp; analytics cookies.</span> Help
            us understand aggregate visitor behaviour — such as which pages are viewed and for how
            long — so we can improve the site. This data is used in aggregate and is not used to
            personally identify you.
          </li>
        </ul>
        <p>We do not currently use third-party advertising or retargeting cookies.</p>
      </LegalSection>

      <LegalSection heading="4. Third-Party Cookies" testid="cookies-section-third-party">
        <p>
          Some functionality on our site may rely on third-party infrastructure providers (for
          example, hosting or form-handling services). These providers may set their own cookies
          in accordance with their own privacy and cookie policies, which we encourage you to
          review if you have concerns.
        </p>
      </LegalSection>

      <LegalSection heading="5. Managing Cookies" testid="cookies-section-manage">
        <p>
          Most web browsers let you control cookies through their settings, including blocking or
          deleting cookies already stored on your device. Please note that disabling essential
          cookies may affect the functionality of forms and other features on this site.
        </p>
        <p>
          You can typically find cookie controls in your browser's "Settings" or "Privacy" menu.
          Refer to your browser's help documentation for specific instructions.
        </p>
      </LegalSection>

      <LegalSection heading="6. Changes to This Policy" testid="cookies-section-changes">
        <p>
          We may update this Cookie Policy periodically to reflect changes in our practices or for
          operational, legal, or regulatory reasons. The "Last updated" date at the top of this page
          reflects the most recent revision.
        </p>
      </LegalSection>

      <LegalSection heading="7. Contact Us" testid="cookies-section-contact">
        <p>If you have questions about our use of cookies, contact us at:</p>
        <p className="text-ink">
          Off-Grid Hydrogen Ltd.<br />
          British Columbia, Canada<br />
          Email: <a href="mailto:info@offgridhydrogen.ca" className="text-teal underline">info@offgridhydrogen.ca</a>
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
